import React, { useEffect, useState } from "react";
import blogAPI from "../../api/BlogApi";
import Blog from "./Card";
import Breadcrump from "../../components/Breadcrump";

function ListPage() {
  const [blogs, setBlogs] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchBlogs(1);
  }, []);

  const fetchBlogs = async (pageNum = 1) => {
    setLoading(true);
    try {
      const limit = 6;
      const res = await blogAPI.listing({ page: pageNum, limit });

      if (res.code === 200) {
        const { pagination, items } = res.data;
        setBlogs((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        setTotalCount(pagination.totalCount);
        setHasMore(pageNum * limit < pagination.totalCount);
      }
    } catch (err) {
      console.error("Error loading blogs:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const onScroll = () => {
      if (
        !loading &&
        hasMore &&
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 200
      ) {
        setPage((p) => p + 1);
      }
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [loading, hasMore]);

  useEffect(() => {
    if (page > 1) fetchBlogs(page);
  }, [page]);

  return (
    <>
      <Breadcrump title="Blog" />

      <section className="blog-list-section">
        <div className="container">
          {/* Header */}
          <div className="blog-list-header">
            <p className="blog-list-eyebrow">Our Journal</p>
            <h1 className="blog-list-heading">Stories & Inspirations</h1>
            {!loading && totalCount > 0 && (
              <p className="blog-list-count">
                Showing <strong>{blogs.length}</strong> of{" "}
                <strong>{totalCount}</strong> stories
              </p>
            )}
            <div className="blog-list-divider" />
          </div>

          {/* Grid */}
          {blogs.length > 0 && (
            <div className="blog-list-grid">
              {blogs.map((blog, index) => (
                <Blog key={blog._id || index} item={blog} />
              ))}
            </div>
          )}

          {/* Skeleton Loader */}
          {loading && (
            <div className="blog-list-grid">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="blog-skeleton">
                  <div className="blog-skeleton-img" />
                  <div className="blog-skeleton-body">
                    <div className="blog-skeleton-line blog-skeleton-title" />
                    <div className="blog-skeleton-line blog-skeleton-desc" />
                    <div className="blog-skeleton-line blog-skeleton-desc short" />
                    <div className="blog-skeleton-line blog-skeleton-btn" />
                  </div>
                </div>
              ))}
            </div>
          )}

          {!hasMore && !loading && blogs.length > 6 && (
            <p className="blog-list-end">— You've reached the end —</p>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;
